export const TRUSTPILOT_BUSINESS_UNIT_ID = "6810256a13b74f3327bfe321";
export const TRUSTPILOT_REVIEW_URL = "https://www.trustpilot.com/review/mypassporthub.com";

export const TRUSTPILOT_BANNER_LINK_QA = "trustpilot-banner-review-link";
export const TRUSTPILOT_MICROSTAR_LINK_QA = "trustpilot-microstar-review-link";
export const TRUSTPILOT_CAROUSEL_LINK_QA = "trustpilot-carousel-review-link";

export const TRUSTPILOT_BANNER_WIDGET = {
  templateId: "53aa8807dec7e10d38f59f32",
  token: "99a979e9-7dd4-419d-8a3e-3e46c61597cd",
  height: "150px",
} as const;

// Trustpilot Micro Star widget - shows compact rating
// Template: https://businessapp.b2b.trustpilot.com/widgetconfigurator
export const TRUSTPILOT_MICROSTAR_WIDGET = {
  templateId: "5419b732fbfb950b10de65e5",
  token: "4d3aba7b-c1ec-433f-bfc5-b45188f4646c",
  height: "24px",
} as const;

// Trustpilot Mini Carousel widget - shows rotating customer reviews
// Template: https://businessapp.b2b.trustpilot.com/widgetconfigurator
// Filters: 4-5 star reviews only, English language
export const TRUSTPILOT_CAROUSEL_WIDGET = {
  templateId: "53aa8912dec7e10d38f59f36",
  token: "d04f2ca4-18ab-48d3-911f-3fef6650e9e5",
  height: "140px",
  stars: "4,5", // Show only 4 and 5 star reviews
  reviewLanguages: "en", // English reviews only
} as const;

// TODO: In future, we will add trustpilot flag inside the BE response metadata
export const TRUSTPILOT_ENABLED_DOMAINS = ["app.mypassporthub.com"];

export const isTrustpilotDomain = (domain?: string) =>
  Boolean(domain && TRUSTPILOT_ENABLED_DOMAINS.includes(domain));
